import ImportCsv from './ImportCsv'

/* import compose from 'recompose/compose'
import withState from 'recompose/withState'

import withUploadFile from './withUploadFile'

export default compose(
  withState('templateName', 'setTemplateName', ''),
  withState('file', 'setFile', null),
  withUploadFile
)(Upload) */
module.exports = ImportCsv



// WEBPACK FOOTER //
// ./src/components/ImportCsv/index.js